const ITEMS = [
  "We work on the root cause, not only on the symptoms",
  "Your body doesn't need another extreme diet — it needs the right system",
  "On a mission to transform 1,000 lives till 2027",
  "No extreme diets. No perfection required",
  "Real life is part of the plan",
  "Start with a conversation",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-forest py-5 overflow-hidden border-y border-gold/20"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-lg sm:text-xl text-ivory/90 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="text-gold text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
